/**
 * Money rendering. Every monetary amount in the application goes through here, for the same
 * reason every date goes through `formatDate`: an amount formatted at its call site is an
 * amount that will eventually be formatted differently at the next one.
 *
 * Always two decimal places, even on a round figure. A rate shown as "31,000" beside one
 * shown as "31,000.50" makes a column of amounts impossible to scan, and a trailing ".00" is
 * what says the value is exact rather than rounded.
 *
 * The grouping separator is the viewer's, through `Intl` — the same machinery the date
 * formatters defer to. The currency symbol is deliberately absent: this system holds one
 * currency, and printing a symbol on every row costs width to say what nothing contradicts.
 */
const MONEY_FORMAT = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Placeholder for an absent amount. An em dash, never a bare zero — they mean different things. */
export const EMPTY_MONEY = '—';

export function formatMoney(value: number | null | undefined): string {
  return typeof value === 'number' && Number.isFinite(value) ? MONEY_FORMAT.format(value) : EMPTY_MONEY;
}
